import React from "react";
import { graphql } from "gatsby";
import multipleSiteEnum from "constants/multipleSiteEnum.js";
import "styles/main.scss";

import Head from "public-components/Head";
import Header from "public-components/Header";
import Footer from "public-components/Footer";
import StoreProvider from "public-components/StoreProvider";
import HeroSection from "homepage-sections/HeroSection";
import NHeroSection from "homepage-sections/nHeroSection";
import ScenarioSection from "homepage-sections/ScenarioSection";
import WhyUsSection from "homepage-sections/WhyUsSection";
import FeaturesGridSection from "homepage-sections/FeaturesGridSection";
import TestimonialsSection from "homepage-sections/TestimonialsSection";
import MetaGridSection from "homepage-sections/MetaGridSection";
import PartnersListSection from "homepage-sections/PartnersListSection";
import CtaSection from "homepage-sections/CtaSection";
import Upgrade from "public-components/Upgrade";
import NotFoundSection from "public-components/NotFoundSection";

import styles from "homepage-sections/HeroSection/HeroSection.module.scss";

const sectionsEnum = {
  heroSection: HeroSection,
  nheroSection: NHeroSection,
  scenarioSection: ScenarioSection,
  whyUsSection: WhyUsSection,
  featuresGridSection: FeaturesGridSection,
  testimonialsSection: TestimonialsSection,
  metaGridSection: MetaGridSection,
  partnersListSection: PartnersListSection,
  ctaSection: CtaSection
};

export default (props) => {
  let linkIndex = 0; // 统计埋点链接索引，自增数字

  const pageData = props.data.craft.entries[0];
  let sectionsArray = pageData.homepageContentBuilder.sort((a, b) => +a.id - +b.id);
  // TODO craft cms 返回顺序出错，待修复
  if (pageData.siteId === 2 || pageData.siteId === 9) {
    // sectionsArray.unshift(sectionsArray.pop());
  }

  const seoData = {
    siteId: pageData.siteId,
    title: pageData.seoTitle,
    description: pageData.seoDescription,
    image: pageData.ogCardImage[0]
  };
  return (
    <StoreProvider>
      <Head data={seoData} />
      <Header
        siteId={pageData.siteId}
        signInButtonModifierClassName={styles.signInButton}
        isHomepage={true}
      />

      {sectionsArray.map((data) => {
        data.currentSlug = pageData.siteId === "1" ? "" : multipleSiteEnum[pageData.siteId];

        // pageLink 是一个数组 （Craft matrix）
        if (Array.isArray(data.pageLink)) {
          data.linkIndex = ++linkIndex;
        }

        const Tag = sectionsEnum[data.typeHandle] || NotFoundSection;
        return <Tag key={data.id} data={data} />;
      })}

      <Footer siteId={pageData.siteId} disableAd={true} />
      <Upgrade siteId={pageData.siteId} />
    </StoreProvider>
  );
};

export const pageQuery = graphql`
  query getHomepage($id: [Craft_QueryArgument]!, $siteId: String!) {
    craft {
      entries(id: $id, siteId: $siteId) {
        siteId
        ... on Craft_homepage_homepage_Entry {
          seoTitle
          seoDescription
          ogCardImage {
            filename
            volumeId
          }
          homepageContentBuilder {
            ... on Craft_homepageContentBuilder_heroSection_BlockType {
              id
              typeHandle
              headingH1
              homeHeroLinksList {
                ... on Craft_homeHeroLinksList_appLink_BlockType {
                  id
                  href
                  text
                  animation
                }
              }
            }
            ... on Craft_homepageContentBuilder_scenarioSection_BlockType {
              id
              typeHandle
              headingH2
              homeScenariosList {
                ... on Craft_homeScenariosList_scenario_BlockType {
                  id
                  heading
                  text
                  image {
                    ... on Craft_sideImage_Asset {
                      title
                      filename
                      volumeId
                    }
                  }
                }
              }
              imagePosition
              pageLink {
                ... on Craft_pageLink_link_BlockType {
                  text
                  href
                  openInNewTab
                }
              }
              appType
            }
            ... on Craft_homepageContentBuilder_whyUsSection_BlockType {
              id
              typeHandle
              headingH2
              homeWhyUsList {
                ... on Craft_homeWhyUsList_whyUs_BlockType {
                  id
                  heading
                  text
                  linkText
                  linkHref
                  image {
                    ... on Craft_sideImage_Asset {
                      title
                      filename
                      volumeId
                    }
                  }
                }
              }
            }
            ... on Craft_homepageContentBuilder_featuresGridSection_BlockType {
              id
              typeHandle
              headingH2
              homeFeaturesList {
                ... on Craft_homeFeaturesList_feature_BlockType {
                  id
                  icon
                  heading
                  text
                }
              }
            }
            ... on Craft_homepageContentBuilder_testimonialsSection_BlockType {
              id
              typeHandle
              headingH2
              homeTestimonialsList {
                ... on Craft_homeTestimonialsList_testimonial_BlockType {
                  id
                  quote
                  author
                  company
                  rate
                }
              }
            }
            ... on Craft_homepageContentBuilder_metaGridSection_BlockType {
              id
              typeHandle
              headingH2
              metaDataList {
                ... on Craft_metaDataList_metadata_BlockType {
                  id
                  icon
                  number
                  text
                }
              }
            }
            ... on Craft_homepageContentBuilder_partnersListSection_BlockType {
              id
              typeHandle
              headingH2
              homePartnersList {
                ... on Craft_partnersImage_Asset {
                  id
                  title
                  filename
                  volumeId
                }
              }
            }
            ... on Craft_homepageContentBuilder_ctaSection_BlockType {
              id
              typeHandle
              headingH2
              buttonText
            }
          }
        }
      }
    }
  }
`;
